import React from 'react';
import { isSmartPhone } from '../../../utilities/helper';
import TeamPreviewMWeb from './index_mWeb';
import TeamPreviewWeb from './index_web';

const TeamPreview = () => {
  return <React.Fragment>{isSmartPhone ? <TeamPreviewMWeb /> : <TeamPreviewWeb />}</React.Fragment>;
};
export default TeamPreview;
